module.exports = __webpack_public_path__ + "static/leaving-a-mark-in-the-marvel-universe-f1ea383a076a2f084b28d74f14e4ba91.jpg";